import React from 'react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <section className="hero">
        <div className="hero-overlay"></div>
        <div className="container hero-content">
          <h1 className="hero-title">ゴルフで繋がる、<br />新しい出会い</h1>
          <p className="hero-subtitle">
            共通の趣味を通じて、自然な出会いを。<br />
            ゴルマチで理想のゴルフパートナーを見つけよう。
          </p>
          <div className="hero-buttons">
            <a href="https://golmachi.onelink.me/ARAS/zgp6qjrm" className="btn btn-primary">アプリをインストール</a>
          </div>
        </div>
      </section>

      <section className="section features">
        <div className="container">
          <h2 className="text-center mb-5">ゴルマチの特徴</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🏌️</div>
              <h3>共通の趣味で繋がる</h3>
              <p>ゴルフという共通の趣味があるから、会話も弾み、自然な関係が築けます。</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>スキルレベルでマッチング</h3>
              <p>初心者から上級者まで、あなたのレベルに合ったパートナーを見つけられます。</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📍</div>
              <h3>近くのゴルフ場で出会う</h3>
              <p>お気に入りのゴルフ場や、新しいコースで一緒にラウンドを楽しめます。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section safety">
        <div className="container">
          <h2 className="text-center mb-5">安全面を徹底しています</h2>
          <div className="safety-grid">
            <div className="safety-card">
              <div className="safety-icon">🔐</div>
              <h3>金融機関でも利用されている本人認証</h3>
              <p>公的証明書による本人確認が必須。安心してご利用いただけます。</p>
            </div>
            <div className="safety-card">
              <div className="safety-icon">🔒</div>
              <h3>登録しても一切投稿されません</h3>
              <p>Google・LINEで登録してもご利用情報が投稿されることはありません。</p>
            </div>
            <div className="safety-card">
              <div className="safety-icon">👤</div>
              <h3>実名が表示されることはありません</h3>
              <p>ニックネームなどでの登録が可能です。プライバシーを守ります。</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section how-it-works">
        <div className="container">
          <h2 className="text-center mb-5">使い方はかんたん</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h4>プロフィール作成</h4>
              <p>ゴルフ歴やプレースタイル、好きなコースなどを登録</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h4>パートナーを探す</h4>
              <p>条件に合うゴルフパートナーを検索・マッチング</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h4>ラウンドを楽しむ</h4>
              <p>マッチしたパートナーと実際にゴルフを楽しもう</p>
            </div>
          </div>
        </div>
      </section>

      <section className="section cta">
        <div className="container text-center">
          <h2 className="mb-3">今すぐゴルマチを始めよう</h2>
          <p className="mb-4">新しいゴルフ仲間との出会いがあなたを待っています</p>
          <a href="https://golmachi.onelink.me/ARAS/zgp6qjrm" className="btn btn-primary">アプリをインストール</a>
        </div>
      </section>
    </div>
  );
};

export default Home;